export default "__VITE_ASSET__DJRowNWa__";